import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-tabActive",
  "use": "icon-tabActive-usage",
  "viewBox": "0 0 2857 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 2857 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-tabActive\"><path d=\"M2180.443429 0a274.651429 274.651429 0 0 1 248.685714 180.150857l229.357714 681.910857a237.732571 237.732571 0 0 0 197.979429 160.365715l0.548571 1.572571H0a237.805714 237.805714 0 0 0 221.257143-161.938286L450.614857 180.150857A274.651429 274.651429 0 0 1 699.300571 0h1481.142858z\" p-id=\"2017\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol